import { motion } from 'framer-motion';
import { useInView } from '../../home/hooks/useInView';

const reasons = [
  {
    icon: 'ri-user-heart-line',
    title: '站在客戶角度思考',
    description: '我們不只是處理文件，更重視理解您的商業目標與需求，提供真正符合您利益的建議。',
  },
  {
    icon: 'ri-chat-smile-3-line',
    title: '清楚易懂的溝通',
    description: '避免艱澀的法律術語，用您能理解的方式說明智產權的重要性與保護策略，讓您做出明智決策。',
  },
  {
    icon: 'ri-shield-star-line',
    title: '專業背景與經驗',
    description: '擁有豐富的智慧財產權實務經驗，熟悉各產業的智產權需求，能提供專業且務實的解決方案。',
  },
  {
    icon: 'ri-compass-3-line',
    title: '策略導向的服務',
    description: '不只是申請專利或商標，更協助您規劃長期的智產權布局，讓智產權成為企業的競爭優勢。',
  },
  {
    icon: 'ri-hand-heart-line',
    title: '值得信賴的夥伴',
    description: '我們重視長期合作關係，提供持續的諮詢與支援，成為您在智產權領域最可靠的夥伴。',
  },
  {
    icon: 'ri-time-line',
    title: '效率與品質兼顧',
    description: '在確保品質的前提下，以最有效率的方式處理您的案件，讓您的創新成果盡快獲得保護。',
  },
];

export function WhyChooseUs() {
  const [ref, isInView] = useInView({ threshold: 0.1 });

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <motion.div
            ref={ref}
            initial={{ opacity: 0, x: -50 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6 }}
          >
            <motion.span
              initial={{ opacity: 0, y: 10 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: 0.1 }}
              className="inline-block px-4 py-2 bg-[#2c5282]/10 rounded-full text-sm font-semibold text-[#2c5282] mb-4"
            >
              為什麼選擇我們
            </motion.span>
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="text-4xl md:text-5xl font-bold text-[#1a365d] mb-6"
              style={{ fontFamily: "'Noto Sans TC', sans-serif" }}
            >
              康普斯智產權事務所的優勢
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="text-lg text-gray-600 mb-8 leading-relaxed"
            >
              我們深知智慧財產權對企業與創作者的重要性。不只是提供專業服務，更重視與客戶建立信任關係，成為您在智產權領域最可靠的夥伴。
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="relative w-full h-[400px] rounded-2xl overflow-hidden shadow-xl"
            >
              <img
                src="https://public.readdy.ai/ai/img_res/6a0be748b1cc1ed63b2799daace04418.jpg"
                alt="專業團隊"
                className="w-full h-full object-cover"
              />
            </motion.div>
          </motion.div>

          {/* Right Content - Reasons Grid */}
          <div className="grid sm:grid-cols-2 gap-6">
            {reasons.map((reason, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                animate={isInView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.5, delay: 0.1 * index }}
                whileHover={{ y: -4 }}
                className="bg-gradient-to-br from-[#f8f9fa] to-white p-6 rounded-xl border border-gray-200 hover:border-[#2c5282] hover:shadow-lg transition-all duration-300"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-[#2c5282]/10 rounded-lg mb-4">
                  <i className={`${reason.icon} text-2xl text-[#2c5282]`}></i>
                </div>
                <h3 className="text-lg font-bold text-[#1a365d] mb-3" style={{ fontFamily: "'Noto Sans TC', sans-serif" }}>
                  {reason.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {reason.description}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}